module.exports = __webpack_public_path__ + "static/media/0_2020_05_29.5dc94284.jpg";